import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import marvarApi from '../../../../api/marvarApi'
import { onLogout } from 'store'

import { useHelpers } from './useHelpers'
import { useGlobalStates } from './useGlobalStates'
import { useDefaultData } from './useDefaultData'
import { useForm } from './useForm'
import * as useFetchData from './useFetchData'
import { useActions } from './useActions'

export const useFetchInitTransactionBank = ({ location, paramsURL }) => {

    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // Helpers ------------------------------------------------------------------------------------
    const Helpers = useHelpers()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({ Helpers })

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [dataModal, setDataModal] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }

    // useForm ------------------------------------------------------------------------------------
    const FilterForm = useForm(defaultData.defaultFilterForm)
    const FormScreen = useForm(defaultData.defaultFormScreen)
    const FilterMovements = useForm(defaultData.defaultFilterMovements)
    const FormMovement = useForm(defaultData.defaultFormMovement)
    const Forms = {
        FilterForm,
        FormScreen,
        FilterMovements,
        FormMovement,
    }

    // FetchData ----------------------------------------------------------------------------------
    const defaultFetchParams = {
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL,
        //------------- globalStates
        globalStates,
        //------------- defaultData
        defaultData,
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms
    }

    const fetchBankDeposits = useFetchData.useFetchBankDeposits({ ...defaultFetchParams })
    const fetchBankMovements = useFetchData.useFetchBankMovements({ ...defaultFetchParams })
    const fetchAllBanks = useFetchData.useFetchAllBanks({ ...defaultFetchParams })
    const fetchBankDepositsReport = useFetchData.useFetchBankDepositsReport({
        ...defaultFetchParams,
        banks: fetchAllBanks.banks,   
    })

    const fetchBankMovementsReport = useFetchData.useFetchBankMovementsReport({ ...defaultFetchParams })

    const FetchData = {
        fetchBankMovementsReport,
        fetchBankDeposits,
        fetchBankMovements,
        fetchAllBanks,
        fetchBankDepositsReport,
    }

    // Actions ------------------------------------------------------------------------------------
    const Actions = useActions({
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL, toggle,
        //------------- globalStates
        globalStates,
        //------------- defaultData
        defaultData,
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms,
        //------------- FetchData
        FetchData
    })

    return Object.freeze({
        //------------- Generales
        location, paramsURL, dataModal, toggle,
        //------------- globalStates
        globalStates,
        //------------- defaultData
        defaultData,
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    })
}
